import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { useToggle } from 'site-modules/shared/hooks/use-toggle';
import { Collapse } from 'site-modules/shared/components/collapse/collapse';

import './about-dealer-reviews-ratings.scss';

const imgSrc = getStaticImageUrl('/dealership/about-dealer-min.svg');
const title = 'About dealer reviews and ratings';
const subCopy =
  'Find new and used car dealerships near you—browse inventory, reviews, and contact information. Visited a dealer recently? Share your experience to help others.';

export function AboutDealerReviewsRatings({ isMobile = false }) {
  const [isOpen, toggleOpen] = useToggle(false);

  return (
    <section className="about-dealer-reviews-ratings rounded-16 bg-blue-90 overlay-white-50 d-flex overflow-hidden">
      <div className="left-border bg-blue-50 col-auto" />
      {isMobile ? (
        <div>
          <div className="d-flex align-items-center">
            <div className="ps-0_5">
              <img src={imgSrc} alt="" loading="lazy" width={107} />
            </div>
            <div className="py-1_25 px-1">
              <button
                className="cursor-pointer p-0 text-start d-flex align-items-center justify-content-between border-0 bg-transparent"
                onClick={toggleOpen}
                aria-expanded={isOpen}
              >
                <h2 className="size-16 text-cool-gray-10">{title}</h2>
                <i
                  className={classNames('text-blue-20 ms-0_5', {
                    'icon-arrow-up3': isOpen,
                    'icon-arrow-down3': !isOpen,
                  })}
                  aria-hidden
                />
              </button>
            </div>
          </div>
          <Collapse id="expanded-subcopy" isOpen={isOpen} transition="0.25s ease-in-out">
            <div className="text-cool-gray-30 px-1 pb-1_25">{subCopy}</div>
          </Collapse>
        </div>
      ) : (
        <div className="d-flex">
          <div className="p-1_25">
            <h2 className="size-16 text-cool-gray-10">{title}</h2>
            <div className="text-cool-gray-30">{subCopy}</div>
          </div>
          <div className="d-flex align-items-center pe-1">
            <img src={imgSrc} alt="" loading="lazy" width={176} />
          </div>
        </div>
      )}
    </section>
  );
}

AboutDealerReviewsRatings.propTypes = {
  isMobile: PropTypes.bool,
};
